import { render } from "./BaseErrorPopup.vue?vue&type=template&id=34d4ab97"
import script from "./BaseErrorPopup.vue?vue&type=script&lang=js"
export * from "./BaseErrorPopup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__